import { ChecklistStepCopy } from './DashboardChecklist.interface';

import {
    BUSINESS_VERIFICATION_COMPLETE_ID,
    COMPLETE_ACCOUNTING_SETUP,
    COMPLETE_PAYROLL_SETUP,
    OPEN_CONNECT_BUSINESS_BANK_ACCOUNTS,
} from 'modules/common/components/Layout/LaunchpadTasks/useLaunchpadSchema/constants';

export const DEFAULT_CTA_LABEL = 'Start';
export const CONTINUE_CTA_LABEL = 'Continue';

export const ACCOUNTING_SETUP_TASK_ID = COMPLETE_ACCOUNTING_SETUP.id;

// Steps not listed keep their launchpad schema copy.
export const STEP_COPY: Record<string, ChecklistStepCopy> = {
    [BUSINESS_VERIFICATION_COMPLETE_ID]: {
        title: 'Verify your business',
        description: 'Provide a few documents to complete your business verification.',
        ctaLabel: 'Verify',
    },
    [OPEN_CONNECT_BUSINESS_BANK_ACCOUNTS.id]: {
        title: 'Connect your business accounts',
        description: 'Connect your accounts so we can categorize transactions and organize your books.',
        ctaLabel: 'Connect',
    },
    [COMPLETE_ACCOUNTING_SETUP.id]: {
        title: 'Set up accounting',
        description: 'Submit your documents and expenses to capture every deduction and complete your books.',
        ctaLabel: 'Set up',
    },
    [COMPLETE_PAYROLL_SETUP.id]: {
        title: 'Set up payroll',
        description: 'Set up payroll to meet S Corp requirements and pay yourself correctly.',
        ctaLabel: 'Set up',
    },
};

export const ACCOUNTING_SUBSTEP_COPY = {
    personalAccounts: {
        id: 'review-personal-accounts',
        title: 'Review personal accounts',
        description: 'Add business transactions from your personal accounts.',
    },
    reimbursements: {
        id: 'claim-reimbursements',
        title: 'Claim reimbursements',
        description: 'Deduct shared costs like home office or vehicle expenses.',
    },
    documents: {
        id: 'submit-documents',
        title: 'Submit your documents',
        description: 'Answer a few questions and upload records to finalize your setup.',
    },
};
